<template>
  <div class="row">
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input
              id="inBlockIPListSearch"
              placeholder="جستجو پیشرفته در لیست مسدود شده ها (Enter)"
              type="text"
              class="form-control form-control-sm rounded-0"
              v-on:focus="$event.target.select()"
              v-on:keyup.enter="searchData($event.target.value)"
            />
            <div class="input-group-prepend rounded-0">
              <span
                class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                "
              >
                <a v-on:click="searchData('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div
          class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
        >
          <a
            class="
              btn btn-secondary btn-sm btn-floating
              p-0
              m-0
              d-flex
              justify-content-around
              align-items-center
            "
            style="width: 120px; height: 30px"
            title="مسدود کردن ip جدید"
            data-toggle="modal"
            data-target="#ModalAddNewBlockIP"
          >
            مسدود کردن ip جدید
            <i class="fas fa-filter fa-1x-half text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary">
          <td style="max-width: 50px">ردیف</td>
          <td>آی پی مسدود شده</td>
          <td>تاریخ مسدود شدن</td>
          <td>مدت مسدود شدن</td>
          <td>تعداد تلاش</td>
          <td>وضعیت</td>
          <td>مدیریت</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="(row, index) in getBlockIpListFromLocall">
            <tr
              :key="row.ID"
              :class="{ selRow: SelectRowData.ID == row.ID }"
              v-on:click="SaveRowSelect(row)"
              v-bind:id="row.ID"
              style="cursor: pointer"
            >
              <!-- ردیف -->
              <td
                style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ index + 1 }}
              </td>
              <!-- آی پی مسدود شده -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.UserIP }}
              </td>
              <!-- تاریخ مسدود شدن -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  direction: ltr;
                "
              >
                {{ row.ShamsiDate }}
              </td>
              <!-- مدت مسدود شدن -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.BlockIPTimeForShow }}
              </td>
              <!-- تعداد تلاش ناموفق -->
              <td 
                style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.CountError }}
              </td>
              <td
                style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                <i v-if="row.ActiveStatus" class="far fa-check-circle fa-lg text-success" title="فعال"></i>
                <i v-else class="far fa-times-circle fa-lg text-warning" title="غیرفعال"></i>
              </td>
              <!-- مدیریت -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "
              >
                <!-- منوی ویرایش مدت مسدود شدن -->
                <a
                  href="#"
                  title="ویرایش مدت مسدود شدن"
                  data-toggle="modal"
                  data-target="#ModalEditBlockIP"
                  v-if="row.ActiveStatus"
                >
                  <!-- <i class="far fa-eye fa-lg m-1 text-primary"></i> -->
                  <i class="fas fa-edit fa-lg m-1 text-success"></i>
                </a>
                <!-- منوی حذف آی پی از لیست مسدود شده ها -->
                <a
                  href="#"
                  title="حذف ip از لیست مسدود شده ها"
                  v-on:click="CallDeleteBlockIP(row)"
                  v-if="row.ActiveStatus"
                >
                  <i class="far fa-trash-alt fa-lg m-1 pink-text"></i>
                </a>
                <span
                  v-else
                >
                  منقضی شده
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- مودال ثبت آی پی جدید -->
    <AddNewBlockIP></AddNewBlockIP>
    <!-- مودال ویرایش آی پی -->
    <EditBlockIP
        v-bind:BlockIPData="SelectRowData"
    ></EditBlockIP>

  </div>
</template>

<script>
import AddNewBlockIP from './Components/AddNewBlockIP.vue'
import EditBlockIP from './Components/EditBlockIP.vue'

export default {
    components:{
        AddNewBlockIP,
        EditBlockIP,
    },
    data() {
        return {
            ListBlockIP: [],
            SelectRowData: { 
                ID: 0, 
                UserIP: '', 
                BlockDate: '', 
                CountError: 0, 
                BlockIPTime: 0
            },
            BlockIPSearch: []
        }
    },
    created() {
        this.getBlockIpListFromServer();
    },
    computed: {
        // دریافت لیست آی پی های مسدود شده از مخزن محلی
        getBlockIpListFromLocall(){
            this.ListBlockIP = this.$store.getters.getListBlockIP;
            return this.ListBlockIP;
        }
    },
    methods: {
        // دریافت لیست آی پی های مسدود شده از سرور
        async getBlockIpListFromServer(){
            // دریافت لیست آی پی های مسدود شده
            let token = await this.$store.getters.getUserData.token;
            await this.$store.dispatch("getBlockIpListFromServer", {token});
        },
        // نگهداری اطلاعات سطر انتخاب شده
        SaveRowSelect(RowData) {
            this.SelectRowData = RowData;
        },
        // رویداد حذف آی پی از لیست مسدود شده ها
        async CallDeleteBlockIP(RowSelect) {
            this.SelectRowData = RowSelect;
            swal({
                title: "تقاضای حذف ip",
                text:
                "آیا آی پی ( " + this.SelectRowData.UserIP + " ) حذف شود ؟",
                icon: "warning", // success, warning, error, info
                buttons: {
                cancel: "انصراف",
                ok: "بله این آی پی حذف شود",
                },
            }).then(async (value) => {
                if (value) {
                    // نمایش لطفا صبر نمایید
                    this.$store.dispatch("pleaseWait", {
                    notText: "حذف ip از سرور",
                    });

                    let token = await this.$store.getters.getUserData.token;
                    var checkDelete = await this.$store.dispatch("DeleteBlockIPToServer", {DeleteBlockIPData: this.SelectRowData, token});

                    // لغو نمایش لطفا صبر نمایید
                    this.$store.dispatch("pleaseWait", {
                    stop: true,
                    });
                }
            });
        },
        // جستجو در لیست آی پی های مسدود شده
        searchData(searchValue) {
        if (searchValue === "Search") {
            searchValue =
            $("#inBlockIPListSearch").val() != ""
                ? $("#inBlockIPListSearch").val()
                : "";
        }
        if (searchValue != "") {
            let index = this.ListBlockIP.findIndex(
            (item) =>
                (item.UserIP.toString().includes(searchValue) ||
                item.ShamsiDate.toString().startsWith(searchValue)) &&
                this.BlockIPSearch.indexOf(item.ID) == -1
            );
            if (index != -1) {
                let BlockIPID = this.ListBlockIP[index].ID;
                $("#" + BlockIPID).scrollintoview({
                    duration: 500,
                    //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
                });
                this.SelectRowData = this.ListBlockIP[index];

                this.BlockIPSearch.push(BlockIPID);
            } else {
                this.$store.dispatch("notify", {
                  notText: "پایان جستجو",
                  timeOut: 1500,
                });
                this.BlockIPSearch = [];
            }
        } else {
            this.$store.dispatch("notify", {
            notText: "مقداری برای جستجو درج نشده است !",
            timeOut: 2500,
            });
            this.BlockIPSearch = [];
        }
        },
    },
}
</script>

<style scoped>
    .selRow {
    background-color: #fbff94;
    }
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ManageBlockIP/ManageBlockIP.vue